// @core/api/endpoints/workflow/get_agent_tool.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AgentToolResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Get agent tool
 * Retrieves an agent tool definition.
 */
export async function GetAgentTool(
  tool_id: string,
  options?: RequestOptions
): Promise<AgentToolResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/agent-tools/:tool_id`;
  requestPath = requestPath.replace(':tool_id', encodeURIComponent(tool_id));
  const requestOptions = options;
  return client.get<AgentToolResponse>(requestPath, { ...requestOptions });
}
